module.exports = __webpack_public_path__ + "static/media/color_logo.3c209e62.png";